import React from 'react'
import NextLink from 'next/link'

export interface LinkProps {
  prefetch?: boolean
  className?: string
  target?: '_blank'
  href?: string
  id?: string
  action?: () => void
  children: React.ReactNode
}

const Link = (props: LinkProps) => {
  const { prefetch = false, children, className, target } = props
  const hasHref = 'href' in props && props.href
  const hasOnClick = 'action' in props && props.action

  if (!hasHref)
    return (
      <a
        id={props.id}
        onClick={hasOnClick ? props.action : undefined}
        target={target}
        className={className}
      >
        {children}
      </a>
    )

  return (
    <NextLink
      prefetch={prefetch}
      href={hasHref}
      id={props.id}
      onClick={props.action}
      target={target}
      className={className}
    >
      {children}
    </NextLink>
  )
}

export default Link
